import React from 'react';
import '../template-file-css/document-file-template.css';


export const RRTS_AuthRequestAmerihealthAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RRTS_AuthRequestAmerihealthAdult' className='file-pdf-document'>
            <div className='file-template'>


                <input type="hidden" id="hdcareq" name="careq" value="true" />
                <h3>Adult Mental Health Rehabilitation Treatment Request Form</h3>
                <p>
                    Please print clearly. Incomplete or illegible forms will delay processing. Please return the completed form to
                    AmeriHealth Caritas Louisiana’s Behavioral Health Utilization Management (BHUM) team at 1-855-301-5356. For assistance, please call<strong>1-855-285-7466</strong>.
                </p>

                <h3>Member information</h3>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Patient name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Legal guardian:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPatient" name="txtPatient" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtLegalGuardian" name="txtLegalGuardian" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Member date of birth:</span></td>
                        <td className='w-375'><span className='eleHeader'>Medicaid/health plan #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtMemberDob" name="txtMemberDob" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtMedicaid" name="txtMedicaid" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Last authorization # (if applicable):</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtLastAuthorization" name="txtLastAuthorization" className='add-only' /></td>
                    </tr>
                </table>

                <h3>Provider information</h3>
                <p>
                    <span className='eleHeader'>Provider name:</span>
                    <input type="text" id="txtProvider" name="txtProvider" className='add-only' />
                </p>
                <p>
                    <input type="checkbox" id="cbParticipating" name="cbParticipating" className='add-only' value="Yes" /> Participating &nbsp;
                    <input type="checkbox" id="cbNotParticipating" name="cbNotParticipating" className='add-only'  value="No" /> No &nbsp;t participating &nbsp;
                    <input type="checkbox" id="cbInCredentialingProcess" name="cbInCredentialingProcess" className='add-only' value="Yes" /> In credentialing process
                </p>

                <p>
                    <span className='eleHeader'>Group/agency name:</span>
                    <input type="text" id="txtGroupAgencyName" name="txtGroupAgencyName" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>Provider credential:</span>
                    <input type="checkbox" id="cbProviderCredential_1" name="cbProviderCredential_1" className='add-only' value="Yes" /> MD &nbsp;
                    <input type="checkbox" id="cbProviderCredential_2" name="cbProviderCredential_2" className='add-only' value="Yes" /> PhD &nbsp;
                    <input type="checkbox" id="cbProviderCredential_3" name="cbProviderCredential_3" className='add-only' value="Yes" /> LMHP &nbsp;
                    <input type="checkbox" id="cbProviderCredential_4" name="cbProviderCredential_4" className='add-only' value="Yes" /> LAC &nbsp;
                    <input type="checkbox" id="cbProviderCredential_5" name="cbProviderCredential_5" className='add-only' value="Yes" /> NP &nbsp;
                    <input type="checkbox" id="cbProviderCredential_6" name="cbProviderCredential_6" className='add-only' value="Yes" /> Other, please specify:

                </p>
                <p>

                    <textarea id="txtPleaseSpecify" name="txtPleaseSpecify" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Physical address:</span>
                    <textarea id="txtPhysicalAddress" name="txtPhysicalAddress" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Phone number:</span></td>
                        <td className='w-375'><span className='eleHeader'>Fax number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtFaxNumber" name="txtFaxNumber" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Medicaid/provider/NPI #:</span></td>
                        <td className='w-375'><span className='eleHeader'>Contact name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtMedicaidProvider" name="txtMedicaidProvider" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtContactName" name="txtContactName" className='add-only' /></td>
                    </tr>
                </table>


                <h3>DSM diagnosis</h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Primary Dx:</span></td>
                        <td className='w-250'><span className='eleHeader'>Secondary Dx</span></td>
                        <td className='w-250'><span className='eleHeader'>Medical Dx</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtPrimaryDx" name="txtPrimaryDx" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtSecondaryDx" name="txtSecondaryDx" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtMedicalDx" name="txtMedicalDx" className='add-only' /></td>
                    </tr>
                </table>
                <p>
                    Please also include the ICD-10 diagnosis code along with DSM code.
                </p>
                <p>
                    <span className='eleHeader'>If the member has a substance use and/or HIV diagnosis, has a consent to release information for these related conditions been obtained?</span>


                    <input type="radio" id="rbHivDiagnosis_Yes" name="rbHivDiagnosis" className='add-only'  value="Yes" /> Yes &nbsp;  &nbsp;
                    <input type="radio" id="rbHivDiagnosis_No" name="rbHivDiagnosis" className='add-only' value="No" /> No &nbsp;
                    <input type="radio" id="rbHivDiagnosis_Na" name="rbHivDiagnosis" className='add-only' value="Na" /> N/A &nbsp;
                </p>

                <h3>Primary care physician (PCP) information and collaboration</h3>
                <p>
                    Has information been shared with the PCP or other providers regarding:
                </p>
                <p>
                    <span className='eleHeader'>The initial evaluation and treatment plan?</span>
                    <input type="radio" id="rbInitialTreatmentPlan_Yes" name="rbInitialTreatmentPlan" className='add-only'  value="Yes" /> Yes &nbsp; &nbsp;
                    <input type="radio" id="rbInitialTreatmentPlan_No" name="rbInitialTreatmentPlan" className='add-only' value="No" /> No
                </p>
                <p>
                    <span className='eleHeader'>The updated evaluation and treatment plan?</span>
                    <input type="radio" id="rbUpdatedTreatmentPlan_Yes" name="rbUpdatedTreatmentPlan" className='add-only'  value="Yes" /> Yes &nbsp; &nbsp;
                    <input type="radio" id="rbUpdatedTreatmentPlan_No" name="rbUpdatedTreatmentPlan" className='add-only' value="No" /> No
                </p>
                <p>
                    <span className='eleHeader'>Other behavioral health provider name and date last notified:</span>
                    <textarea id="txtOtherBehavioralHealthProviderName" name="txtOtherBehavioralHealthProviderName" className='add-only'></textarea>
                </p>
                <p>
                    If no, please explain:
                    <textarea id="txtOtherBehavioralHealthProviderNameExplain" name="txtOtherBehavioralHealthProviderNameExplain" className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Suicidal</span></td>
                        <td className='w-250'><span className='eleHeader'>Homicidal</span></td>
                        <td className='w-250'><span className='eleHeader'>Assault/violent</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbSuicidal_None" name="rbSuicidal" className='add-only' value="1" /> 1 None &nbsp; <br/>
                            <input type="radio" id="rbSuicidal_Low" name="rbSuicidal" className='add-only' value="2" /> 2 Low &nbsp; <br/>
                            <input type="radio" id="rbSuicidal_Moderate" name="rbSuicidal" className='add-only' value="3" /> 3 Moderate &nbsp; <br/>
                            <input type="radio" id="rbSuicidal_High" name="rbSuicidal" className='add-only' value="4" /> 4 High &nbsp; <br/>
                            <input type="radio" id="rbSuicidal_Extreme" name="rbSuicidal" className='add-only' value="5" /> 5 Extreme
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbHomicidal_None" name="rbHomicidal" className='add-only' value="1" /> 1 None &nbsp; <br/>
                            <input type="radio" id="rbHomicidal_Low" name="rbHomicidal" className='add-only' value="2" /> 2 Low &nbsp; <br/>
                            <input type="radio" id="rbHomicidal_Moderate" name="rbHomicidal" className='add-only' value="3" /> 3 Moderate &nbsp; <br/>
                            <input type="radio" id="rbHomicidal_High" name="rbHomicidal" className='add-only' value="4" /> 4 High &nbsp; <br/>
                            <input type="radio" id="rbHomicidal_Extreme" name="rbHomicidal" className='add-only' value="5" /> 5 Extreme &nbsp;
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbAssault_None" name="rbAssault" className='add-only' value="1" /> 1 None &nbsp; <br/>
                            <input type="radio" id="rbAssault_Low" name="rbAssault" className='add-only' value="2" /> 2 Low &nbsp; <br/>
                            <input type="radio" id="rbAssault_Moderate" name="rbAssault" className='add-only' value="3" /> 3 Moderate &nbsp; <br/>
                            <input type="radio" id="rbAssault_High" name="rbAssault" className='add-only' value="4" /> 4 High &nbsp; <br/>
                            <input type="radio" id="rbAssault_Extreme" name="rbAssault" className='add-only' value="5" /> 5 Extreme
                        </td>
                    </tr> 
                </table>

                <h3>Medications</h3>
                <p>
                    <span className='eleHeader'>Is member prescribed medications?</span>
                    <input type="radio" id="rbMemberPrescribedMedications_Yes" name="rbMemberPrescribedMedications" className='add-only'  value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMemberPrescribedMedications_No" name="rbMemberPrescribedMedications" className='add-only'  value="0" /> No &nbsp;
                </p>
                <p>
                    Prescribing physician(s) name(s):
                    <textarea id="txtPrescribingPhysician" name="txtPrescribingPhysician" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Is member compliant with medications?</span>
                    <input type="radio" id="rbCompliantMedications_Yes" name="rbCompliantMedications" className='add-only'  value="1" /> Yes &nbsp;
                    <input type="radio" id="rbCompliantMedications_No" name="rbCompliantMedications" className='add-only'  value="0" /> No &nbsp;
                </p>

                <p>
                    <span className='eleHeader'>Please list medications and dosages:</span>
                    <textarea id="txtListMedications" name="txtListMedications" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Please attach the following to the authorization request:</span>

                    <input type="radio" id="rbClinicalAssessment" name="rbAuthorizationRequest" className='add-only' value="1" /> Clinical assessment &nbsp; &nbsp;
                    <input type="radio" id="rbTreatmentPlan" name="rbAuthorizationRequest" className='add-only' value="2" /> Treatment plan &nbsp; &nbsp;
                    <input type="radio" id="rbChoiceProviderForm" name="rbAuthorizationRequest" className='add-only' value="3" /> Choice in provider form
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>LOCUS: Date of completion:</span></td>
                        <td className='w-375'><span className='eleHeader'>LMHP name with credentials:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtLocusDate" name="txtLocusDate" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtLmhpName" name="txtLmhpName" className='add-only' /></td>
                    </tr>
                </table>


                <h3>Treatment request (please check services being requested)</h3>
                <p>
                    <input type="checkbox" id="cbTreatmentRequest" name="cbTreatmentRequest" className='add-only' value="Yes" />
                    <strong>Community psychiatric support and treatment (CPST):</strong> Goal-directed and solution-focused community-based interventions.
                </p>
                <p>
                    Service code:
                    <input type="text" id="txtServiceCode" name="txtServiceCode" defaultValue={'H0036'} className='add-only' />
                    Number of units:
                    <input type="text" id="txtNumberUnits" name="txtNumberUnits" defaultValue={'5'} className='add-only' />
                    per week
                </p>
                <p>
                    <input type="checkbox" id="cbAct" name="cbAct" className='add-only' value="Yes" />
                    <strong>Assertive community treatment (ACT)</strong>
                </p>
                <p>
                    Service code:
                    <input type="text" id="txtServiceCodeAct" name="txtServiceCodeAct" className='add-only' />
                    Number of units:
                    <input type="text" id="txtNumberUnitsAct" name="txtNumberUnitsAct" className='add-only' />
                    per week
                </p>

                <p>
                    <input type="checkbox" id="cbPsr" name="cbPsr" className='add-only' value="Yes" />
                    <strong>PSR (psychosocial rehabilitation):</strong> Services to restore a member to the fullest possible extent as an active and productive member of his or her family and community.
                </p>
                <p>
                    <span className='eleHeader'>PSR individual in the office number of units per week:</span>
                    <input type="text" id="txtIndividualOfficeNumberUnitsPerWeek" name="txtIndividualOfficeNumberUnitsPerWeek" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>PSR individual in the community number of units per week:</span>
                    <input type="text" id="txtIndividualCommunityNumberUnitsPerWeek" name="txtIndividualCommunityNumberUnitsPerWeek" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>PSR group in the office number of units per week:</span>
                    <input type="text" id="txtGroupOfficeNumberUnitsPerWeek" name="txtGroupOfficeNumberUnitsPerWeek" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>PSR group in the community number of units per week:</span>
                    <input type="text" id="txtGroupCommunityNumberUnitsPerWeek" name="txtGroupCommunityNumberUnitsPerWeek" className='add-only' />
                </p>

                <p>
                    <input type="checkbox" id="cbCrisisIntervention" name="cbCrisisIntervention" className='add-only' value="Yes" />
                    <strong>Crisis intervention follow up:</strong> The member has received emergent crisis intervention services in the initial 24 hour period of the crisis and now requires additional crisis
                    intervention follow up. Services are authorized up to 66 hours per episode and cannot exceed 14 days.
                </p>
                <p>
                    Service code:
                    <input type="text" id="txtServiceCodeCrisisIntervention" name="txtServiceCodeCrisisIntervention" className='add-only' />
                    Number of units:
                    <input type="text" id="txtNumberUnitsCrisisIntervention" name="txtNumberUnitsCrisisIntervention" className='add-only' />
                    per week
                </p>

                <h3>For all initial requests, please indicate below:</h3>
                <p>
                    <span className='eleHeader'>1. Treatment plan:</span>
                </p>
                <p>
                    please clearly indicate the service (e.g., CPST or PSR) and what interventions (e.g., anger management,
                    social skills, etc.) will be provided under each service requested. Please specify, for each intervention, the duration and
                    frequency of delivery per week (e.g., 30-minute sessions, twice per week) and the number of weeks needed to complete one
                    cycle of intervention (e.g, social skill training lasts 12 weeks, relaxation training and practice sessions lasts eight weeks, etc.).
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_1" name="txtProblem_1" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_1" name="txtMentalHealth_1" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_1" name="txtTypeIntervention_1" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_1" name="txtDurationFrequency_1" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_1" name="txtLengthIntervention_1" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_1" name="txtProvideIntervention_1" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_2" name="txtProblem_2" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_2" name="txtMentalHealth_2" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_2" name="txtTypeIntervention_2" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_2" name="txtDurationFrequency_2" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_2" name="txtLengthIntervention_2" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_2" name="txtProvideIntervention_2" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_3" name="txtProblem_3" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_3" name="txtMentalHealth_3" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_3" name="txtTypeIntervention_3" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_3" name="txtDurationFrequency_3" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_3" name="txtLengthIntervention_3" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_3" name="txtProvideIntervention_3" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_4" name="txtProblem_4" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_4" name="txtMentalHealth_4" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_4" name="txtTypeIntervention_4" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_4" name="txtDurationFrequency_4" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_4" name="txtLengthIntervention_4" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_4" name="txtProvideIntervention_4" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_5" name="txtProblem_5" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_5" name="txtMentalHealth_5" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_5" name="txtTypeIntervention_5" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_5" name="txtDurationFrequency_5" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_5" name="txtLengthIntervention_5" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_5" name="txtProvideIntervention_5" className='add-only' />
                </p>
                <p>
                    <span className='eleHeader'>1a. If you are requesting to provide both CPST and PSR, please explain the need for both services and how the services will differ in content:</span>
                    <textarea id="txtTreatmentPlan_1A" name="txtTreatmentPlan_1A" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>1b. If the member has not had any prior behavioral health services, please provide reasons why clinic-based services are not an option:</span>
                    <textarea id="txtTreatmentPlan_1B" name="txtTreatmentPlan_1B" className='add-only'></textarea>
                </p>


                <p>
                    <span className='eleHeader'>2. The member is unable to be managed at a less intensive level of care safely within the last week.</span>
                    <input type="radio" id="rbLessIntensiveLevel_Yes" name="rbLessIntensiveLevel" className='add-only'  value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbLessIntensiveLevel_No" name="rbLessIntensiveLevel" className='add-only'  value="No" /> No &nbsp;
                </p>

                <p>
                    <span className='eleHeader'>3. Is the member currently in short-term respite or any other mental health/substance use disorder service(s)?</span>
                    <input type="radio" id="rbDisorderService_Yes" name="crDisorderService" className='add-only'  value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbDisorderService_No" name="crDisorderService" className='add-only'  value="No" /> No &nbsp;
                </p>
                <p>
                    If yes, explain:
                    <textarea id="txtDisorderServiceYesExplain" name="txtDisorderServiceYesExplain" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>4. The member has displayed any of the following within the last week:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_1" name="cbMemberDisplayed_1" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Substance use disorder </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_2" name="cbMemberDisplayed_2" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Lacks motivation for substance use disorder treatment </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_3" name="cbMemberDisplayed_3" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Non-suicidal self-injury </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_4" name="cbMemberDisplayed_4" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Obsessions or compulsions </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_5" name="cbMemberDisplayed_5" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Inability to utilize or the absence of formal or informal supports (health care providers, family, friends, etc.) </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_6" name="cbMemberDisplayed_6" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Repeated failure to follow through with acute psychiatric discharge plans </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_7" name="cbMemberDisplayed_7" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Suicidal ideations </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_8" name="cbMemberDisplayed_8" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Delusions/ hallucinations </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_9" name="cbMemberDisplayed_9" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Disorganized thoughts, speech, or behavior </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_10" name="cbMemberDisplayed_10" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Hypomanic or hypermanic symptoms increased and/or psychomotor agitation </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_11" name="cbMemberDisplayed_11" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Repeated acute psychiatric hospitalizations </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_12" name="cbMemberDisplayed_12" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Psychiatric medication noncompliance </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberDisplayed_13" name="cbMemberDisplayed_13" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Difficulty with activities of daily living such as cooking, cleaning, financial management, shopping, attending appointments, etc., due to mental illness or substance use disorder </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>5. Have the behaviors been persistent for at least six months?</span>
                    <input type="checkbox" id="rbBehaviorsPersistent_Yes" name="rbBehaviorsPersistent" className='add-only'  value="Yes" /> Yes &nbsp;
                    <input type="checkbox" id="rbBehaviorsPersistent_No" name="rbBehaviorsPersistent" className='add-only'  value="No" /> No &nbsp;
                </p>

                <p>
                    <span className='eleHeader'>6. Are the behaviors expected to continue longer than one year without treatment?</span>
                    <input type="checkbox" id="rbBehaviorExpectedContinue_Yes" name="rbBehaviorExpectedContinue" className='add-only'  value="Yes" /> Yes &nbsp;
                    <input type="checkbox" id="rbBehaviorExpectedContinue_No" name="rbBehaviorExpectedContinue" className='add-only'  value="No" /> No &nbsp;
                </p>

                <p>
                    <span className='eleHeader'>7. The member has had unsuccessful treatment history (lack of improvement) in any of the following within the last month (check all that apply):</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_1" name="cbUnsuccessfulTreatmentHistory_1" className='add-only' value="Yes" /> Group home</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_2" name="cbUnsuccessfulTreatmentHistory_2" className='add-only' value="Yes" /> Outpatient therapy services</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_3" name="cbUnsuccessfulTreatmentHistory_3" className='add-only' value="Yes" /> Psychiatric inpatient admission(s)</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_4" name="cbUnsuccessfulTreatmentHistory_4" className='add-only' value="Yes" /> Residential treatment</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_5" name="cbUnsuccessfulTreatmentHistory_5" className='add-only' value="Yes" /> Substance use disorder treatment</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_6" name="cbUnsuccessfulTreatmentHistory_6" className='add-only' value="Yes" /> Therapeutic group home</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbUnsuccessfulTreatmentHistory_7" name="cbUnsuccessfulTreatmentHistory_7" className='add-only' value="Yes" /> Mental health rehabilitation services (CPST, PSR, ACT)</td>
                    </tr>
                </table>



                <p>
                    <span className='eleHeader'>8. The member’s support system is any of the following within the last month (check all that apply):</span>
                </p>
                <table>
                    <tr>
                        <td className='w-400'>
                            <input type="checkbox" id="cbMemberSupportSystem_1" name="cbMemberSupportSystem_1" className='add-only' value="Yes" /> Abusive</td>
                        <td className='w-350'>
                            <input type="checkbox" id="cbMemberSupportSystem_2" name="cbMemberSupportSystem_2" className='add-only' value="Yes" /> Intentionally sabotages treatments</td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type="checkbox" id="cbMemberSupportSystem_3" name="cbMemberSupportSystem_3" className='add-only' value="Yes" /> Involved in treatment and treatment planning</td>
                        <td className='w-350'>
                            <input type="checkbox" id="cbMemberSupportSystem_4" name="cbMemberSupportSystem_4" className='add-only' value="Yes" /> Unable to ensure safety</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_5" name="cbMemberSupportSystem_5" className='add-only' value="Yes" /> Unable to manage the intensity of the member’s symptoms without a structured program</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberSupportSystem_6" name="cbMemberSupportSystem_6" className='add-only' value="Yes" /> High risk environment (please specify what makes it high risk):</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtMemberSupportSystem_6" name="txtMemberSupportSystem_6" className='add-only' /></td>
                    </tr>
                </table>

                <h3>For all continued stay requests, please indicate the below:</h3>
                <p>
                    <span className='eleHeader'>1. Within the last month the member has experienced and/or displayed the following (check all that apply):</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_1" name="cbMemberExperienced_1" className='add-only' value="Yes" /> Depressed mood with associated symptoms</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_2" name="cbMemberExperienced_2" className='add-only' value="Yes" /> Psychiatric medication noncompliance</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberExperienced_3" name="cbMemberExperienced_3" className='add-only' value="Yes" /> Has ongoing isolation and/or inappropriate social behaviors</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_4" name="cbMemberExperienced_4" className='add-only' value="Yes" /> Paranoia</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_5" name="cbMemberExperienced_5" className='add-only' value="Yes" /> Has had an after-hour crisis</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_6" name="cbMemberExperienced_6" className='add-only' value="Yes" /> Hypomanic symptoms</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_7" name="cbMemberExperienced_7" className='add-only' value="Yes" /> Obsessions/compulsions</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_8" name="cbMemberExperienced_8" className='add-only' value="Yes" /> Psychosis</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_9" name="cbMemberExperienced_9" className='add-only' value="Yes" /> Has been arrested</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberExperienced_10" name="cbMemberExperienced_10" className='add-only' value="Yes" /> Suicidal and/or homicidal ideations (with or without intent)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberExperienced_11" name="cbMemberExperienced_11" className='add-only' value="Yes" /> Post-traumatic stress disorder or history of trauma</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberExperienced_12" name="cbMemberExperienced_12" className='add-only' value="Yes" /> Is neglecting ADLs and/or needs monitoring for ADLs</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberExperienced_13" name="cbMemberExperienced_13" className='add-only' value="Yes" /> Job or daily structured activities interrupted</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMemberExperienced_14" name="cbMemberExperienced_14" className='add-only'  value="No" /> No &nbsp;n-suicidal self-injury</td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbMemberExperienced_15" name="cbMemberExperienced_15" className='add-only' value="Yes" /> Substance use disorder history with high risk for relapse</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberExperienced_16" name="cbMemberExperienced_16" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Disruptive behaviors (check all that apply): </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_160" name="cbMemberExperienced_160" className='add-only' value="Yes" /> Has been arrested or negative contact with law enforcement</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_161" name="cbMemberExperienced_161" className='add-only' value="Yes" /> Physical altercations</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_162" name="cbMemberExperienced_162" className='add-only' value="Yes" /> Destruction of property</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_163" name="cbMemberExperienced_163" className='add-only' value="Yes" /> Stalking</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_164" name="cbMemberExperienced_164" className='add-only' value="Yes" /> Theft</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" id="cbMemberExperienced_17" name="cbMemberExperienced_17" className='add-only' value="Yes" /> </td>
                        <td className='w-730'>Has interpersonal conflicts (check all that apply): </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_170" name="cbMemberExperienced_170" className='add-only' value="Yes" /> Anger outburst</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_171" name="cbMemberExperienced_171" className='add-only' value="Yes" /> Poor boundaries</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_172" name="cbMemberExperienced_172" className='add-only' value="Yes" /> Manipulative</td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type="checkbox" id="cbMemberExperienced_173" name="cbMemberExperienced_173" className='add-only' value="Yes" /> Hostile/intimidating</td>
                    </tr>
                </table>


                <p>
                    <span className='eleHeader'>2. The member is receiving the following services:</span>
                </p>


                <p>
                    <strong>Treatment plan:</strong>
                </p>
                <p>
                    please clearly indicate the service (e.g., CPST or PSR) and what interventions (e.g., anger management,
                    social skills, etc.) will be provided under each service requested. Please specify, for each intervention, the duration and
                    frequency of delivery per week (e.g., 30-minute sessions, twice per week) and the number of weeks needed to complete one
                    cycle of intervention (e.g, social skill training lasts 12 weeks, relaxation training and practice sessions lasts eight weeks, etc.).
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_6" name="txtProblem_6" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_6" name="txtMentalHealth_6" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_6" name="txtTypeIntervention_6" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_6" name="txtDurationFrequency_6" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_6" name="txtLengthIntervention_6" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_6" name="txtProvideIntervention_6" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_7" name="txtProblem_7" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_7" name="txtMentalHealth_7" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_7" name="txtTypeIntervention_7" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_7" name="txtDurationFrequency_7" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_7" name="txtLengthIntervention_7" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_7" name="txtProvideIntervention_7" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_8" name="txtProblem_8" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_8" name="txtMentalHealth_8" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_8" name="txtTypeIntervention_8" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_8" name="txtDurationFrequency_8" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_8" name="txtLengthIntervention_8" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_8" name="txtProvideIntervention_8" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_9" name="txtProblem_9" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_9" name="txtMentalHealth_9" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_9" name="txtTypeIntervention_9" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_9" name="txtDurationFrequency_9" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_9" name="txtLengthIntervention_9" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_9" name="txtProvideIntervention_9" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>Problem/goal</span>
                    <input type="text" id="txtProblem_10" name="txtProblem_10" className='add-only' />
                </p>
                <p>
                    <strong>Mental health rehabilitation service</strong>
                    <br />
                    <input type="text" id="txtMentalHealth_10" name="txtMentalHealth_10" className='add-only' />
                </p>
                <p>
                    <strong>Type of intervention</strong>
                    <br />
                    <input type="text" id="txtTypeIntervention_10" name="txtTypeIntervention_10" className='add-only' />
                </p>
                <p>
                    <strong>Duration (minutes) and frequency (sessions per week)</strong>
                    <br />
                    <input type="text" id="txtDurationFrequency_10" name="txtDurationFrequency_10" className='add-only' />
                </p>
                <p>
                    <strong>Length of intervention (weeks needed to complete one cycle)</strong>
                    <br />
                    <input type="text" id="txtLengthIntervention_10" name="txtLengthIntervention_10" className='add-only' />
                </p>
                <p>
                    <strong>Who will provide the intervention?</strong>
                    <br />
                    <input type="text" id="txtProvideIntervention_10" name="txtProvideIntervention_10" className='add-only' />
                </p>

                <p>
                    <span className='eleHeader'>2a. If you are requesting to provide both CPST and PSR please explain the need for both services and how the services will
                        differ in content:
                    </span>
                    <textarea id="txtTreatmentPlan_2A" name="txtTreatmentPlan_2A" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>2b. Provide reasons why clinic-based services are not an option for this member at this time:</span>
                    <textarea id="txtTreatmentPlan_2B" name="txtTreatmentPlan_2B" className='add-only'></textarea>
                </p>


                <p>
                    <span className='eleHeader'>3. Additional clinical information to support the medical necessity of the requested services:</span>
                    <textarea id="txtAdditionalClinicalInformation" name="txtAdditionalClinicalInformation" className='add-only' ></textarea>
                </p>


            </div>
        </form>

    )
}   